{
  "level": {
    "excellent": "Highly capable",
    "capable": "Capable",
    "marginal": "Marginal",
    "not_capable": "Not capable",
    "no_variation": "No variation",
    "insufficient": "Need more pieces",
    "no_limits": "No limits"
  },
  "help": {
    "cp": "Cp: could the spread fit the tolerance if it were centred? Short-term variation.",
    "cpk": "Cpk: does it fit, given where it actually sits? Short-term variation. 1.33 or more is the usual target.",
    "pp": "Pp: like Cp, but using all the variation across every FAI (long-term).",
    "ppk": "Ppk: like Cpk, but using all the variation across every FAI (long-term).",
    "cpNeedsLimits": "Cp needs both limits.",
    "ppNeedsLimits": "Pp needs both limits."
  },
  "rev": "Rev {{rev}}",
  "button": {
    "aria": "Capability of balloon {{label}}",
    "title": "Capability across all pieces and FAIs of this part"
  },
  "pop": {
    "title": "Balloon {{label}} capability",
    "loading": "Loading",
    "failed": "Could not load capability.",
    "openCharts": "Open charts for this part"
  },
  "section": {
    "empty": "Measure at least 2 pieces to see capability. Deburr pools the readings of every piece and every FAI of this part, then shows how comfortably each characteristic fits its tolerance (Cpk) and whether the process is stable.",
    "attention_one": "{{count}} characteristic needs attention. Worst first. Cpk of 1.33 or more is the usual target.",
    "attention_other": "{{count}} characteristics need attention. Worst first. Cpk of 1.33 or more is the usual target.",
    "allCapable": "Every measured characteristic is capable. Cpk of 1.33 or more is the usual target.",
    "balloon": "Balloon",
    "requirement": "Requirement",
    "readings": "Readings",
    "verdict": "Verdict",
    "fais": " / {{count}} FAIs",
    "out": ", {{count}} out",
    "unusual": ", {{count}} unusual",
    "detailTitle": "Balloon {{label}}"
  },
  "view": {
    "readings": "Readings",
    "fais_one": "{{count}} FAI",
    "fais_other": "{{count}} FAIs",
    "mini_one": "{{count}} reading, {{fais}}",
    "mini_other": "{{count}} readings, {{fais}}",
    "pointLabel": "{{fai}}{{rev}}, SN {{serial}}",
    "stats": "Average {{mean}} {{unit}}, spread (σ) {{sd}}, range {{min}} to {{max}}",
    "outOfTol": ", {{count}} out of tolerance",
    "overTime": "Over time",
    "chartType": "Chart type",
    "eachPiece": "Each piece (I-MR)",
    "perFai": "Per FAI (X̄-R)",
    "xbarTitle": "FAI average (X̄)",
    "rangeTitle": "FAI range (R)",
    "subgroupLabel": "{{fai}}{{rev}}, {{count}} pieces",
    "rangeLabel": "{{fai}}, max minus min",
    "iTitle": "Each reading (I)",
    "mrTitle": "Change from the previous reading (MR)",
    "legendReadings": "readings",
    "legendControl": "control limits (natural spread)",
    "legendTol": "tolerance limits",
    "legendUnusual": "unusual point",
    "unusualTitle": "Unusual points",
    "more": "and {{count}} more",
    "unusualHint": "These hint that something changed (setup, tool, material). Worth a look even when parts are in tolerance.",
    "stable": "No unusual patterns: the process looks stable.",
    "from": "From",
    "asBalloon": " as balloon {{label}}",
    "otherLimits": " with other limits"
  },
  "chart": {
    "histAria": "Histogram of {{count}} readings",
    "lowerLimit": ", lower limit {{v}}",
    "upperLimit": ", upper limit {{v}}",
    "bin_one": "{{count}} reading",
    "bin_other": "{{count}} readings",
    "binRange": "{{lo}} to {{hi}} {{unit}}",
    "lsl": "LSL",
    "usl": "USL",
    "ucl": "UCL",
    "cl": "CL",
    "lcl": "LCL",
    "aria": "{{title}}: {{count}} points",
    "flagged": ", {{count}} flagged"
  }
}
